export const fontFamily = `'Open Sans', sans-serif`
